import { render, staticRenderFns } from "./HeaderImg.vue?vue&type=template&id=73089586&scoped=true&"
import script from "./HeaderImg.vue?vue&type=script&lang=ts&"
export * from "./HeaderImg.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderImg.vue?vue&type=style&index=0&id=73089586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73089586",
  null
  
)

export default component.exports